'use client';

import React, { Suspense } from "react";
import { usePathname } from "next/navigation";
import Header from "../Header";
import Footer from "../Footer";
import WhatsapChatBot from "../WhatsapChatBot/WhtsapChatBot";
import { ToastContainer } from "react-toastify";
import PageViewFacebookPixel from "../Facebook/pixel";
import "react-toastify/dist/ReactToastify.css";

export default function ClientLayoutWrapper({ children }) {
  const pathname = usePathname();

  const excludedPaths = ["/searchresult", "/searchresult/checkout"];
  const showWhatsAppBot = !excludedPaths.includes(pathname);

  const noLayoutPaths = [
    "/bank-details",
    "/cancellation",
    "/shushilsig",
    "/shushilsig/e-mail",
    "/simranthakursig",
  ];

  const hideLayout = noLayoutPaths.includes(pathname);

  if (hideLayout) {
    return <>{children}</>;
  }

  return (
    <>
      <Suspense fallback={null}>
        <Header />
      </Suspense>
      {children}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="light"
      />
      <Footer />
      {showWhatsAppBot && <WhatsapChatBot />}
      <PageViewFacebookPixel />
    </>
  );
}